import React from 'react';

import { Button, Divider, Header, Text } from '@rbilabs/universal-components';
import { EnvItem, HiddenSection } from 'features/diagnostics/components';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import AuthStorage from 'utils/cognito/storage';
import crashlytics from 'utils/crashlytics';
import { StorageKeys } from 'utils/local-storage';

import { ConfigSettings, ExperimentFlags, LDFlags, LocalStorageItems } from '../components';

import { StoreDiagnostics } from './store-diagnostics';

export const InternalDiagnostics = () => {
  const enableInternalDiagnosticTools = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);

  if (!enableInternalDiagnosticTools) {
    return null;
  }

  return (
    <>
      <Header pt={4} variant="headerFour">
        User Auth Info
      </Header>
      <EnvItem envKey="Auth Token" value={AuthStorage.getItem(StorageKeys.USER_AUTH_TOKEN)} />
      <Divider />
      <Divider />
      <ExperimentFlags />
      <Divider />
      <ConfigSettings />
      <Divider />
      <LDFlags />
      <Divider />
      <LocalStorageItems />
      <Divider />
      <HiddenSection
        title="Force Crash App"
        content={
          <>
            <Text marginBottom={'$5'}>
              Force Crash the App. Useful for testing crash handling, logging or other situations.
            </Text>
            <Button onPress={() => crashlytics().crash()}>Force Crash App</Button>
          </>
        }
      />
      <Divider />
      <StoreDiagnostics />
    </>
  );
};
